// extracted by mini-css-extract-plugin
module.exports = {"groupDiv":"Groups_groupDiv__3Ln2H"};